




import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import { CouponStatus } from '@/modules/coupon/models/coupon-resource.model'

@Component
export default class AdminCouponStatus extends Vue {
  @Prop({ required: true }) couponStatus: CouponStatus
  @Prop() couponStatusInPersian: { [key in CouponStatus]: string }
  @Prop() forceLabel: string

  get statusLabel() {
    return this.forceLabel
    || this.couponStatusInPersian ? this.couponStatusInPersian[this.couponStatus] : this.couponStatus
  }

  get colorClass() {
    return this.couponStatus === CouponStatus.ACTIVE ? 'text-tes-green' : 'text-tes-red'
  }
}
